import { FaFacebook , SiInstagram , FaYoutube , SiGithub,FaReddit,SiDiscord } from 'react-icons/all';

export const links = [
	{
		id: 1,
		icon: FaFacebook,
		text: 'facebook',
		link: 'https://www.facebook.com/profile.php?id=100069116769192'
	},
	{
		id: 2,
		icon: SiInstagram,
		text: 'instagram',
		link: 'https://www.instagram.com/thebyteknights/'
	},
	{
		id: 3,
		icon: FaYoutube,
		text: 'youtube',
		link: 'https://www.youtube.com/channel/UCqDxCutv0nzcx0uZrFM76lA'
	},
	{
		id: 4,
		icon: SiGithub,
		text: 'github',
		link: 'https://github.com/TheByteKnights2021/'
	},
	{
		id: 5,
		icon:  FaReddit,
		text: 'Reddit',
		link: 'https://www.reddit.com/r/byteknights/?utm_medium=android_app&utm_source=share'
	},
	{
		id: 6,
		icon:  SiDiscord,
		text: 'Discord',
		link: 'https://discord.gg/v2r5fDaN'
	},
]
